import Cookies from 'js-cookie';
import { IUserLoginInfo } from '@/api/user';
import { PromiseState } from '@/constants';

let isLoad = false;
const loadScript = function (callback: () => void) {
  if (isLoad) return;
  isLoad = true;
  const isProd = process.env.ENV === 'prod';
  const scriptSrc = isProd
    ? `https://account.djicdn.com/account-center-feedback-fe/prod/generate.umd.js?t=${new Date().getTime()}`
    : `https://account-cdn.dbeta.me/account-center-feedback-fe/${process.env.ENV === 'pre-prod' ? 'test' : process.env.ENV
    }/generate.umd.js?t=${new Date().getTime()}`;

  // 创建一个 <script> 元素
  var script = document.createElement('script');

  // 设置 <script> 元素的 src 属性
  script.src = scriptSrc;

  // 设置 <script> 元素的 async 属性为 true
  script.async = true;

  script.onload = function () {
    callback && callback();
  };

  // 将 <script> 元素添加到 <body> 中
  document.body.appendChild(script);
}

const APP_ID = 'bbs';
const APP_NAME = 'bbs';
const LANG = 'zh_CN';
const REGION = 'CN';

function render(account: IUserLoginInfo, isMobile: boolean, el?: HTMLElement | null) {
  const mobileConfig = {
    supportMobile: true,
    mobileBottom: '70px',
    feedbackTop: '60px',
    feedbackMobileTop: '60px',
  };

  const feedBackInit = () => {
    (window as any).accountCenterFeedback?.updateConfig({
      el,
      bottom: 0,
      right: 0,
      lang: LANG,
      appId: APP_ID,
      appName: APP_NAME,
      appUserId: Cookies.get('fb_v1') || Cookies.get('_ga'),
      region: REGION,
      login: account?.status === PromiseState.FULFILLED,
      env: process.env.ENV,
      ...(isMobile ? mobileConfig : {}),
      analyticsCallbackObj: {
        // 点击选项回调
        onClickOption: () => {
          setTimeout(() => {
            const domEle = document.querySelector('.account-feedback-global  textarea[class*=Area]')
            if (domEle) {
              const key = '__feedback_blur_handler';
              if (window[key]) {
                domEle.removeEventListener('blur', window[key]);
              }
              const handler = () => {
                window.scrollTo(0, 0);
              }
              window[key] = handler;
              domEle.addEventListener('blur', handler);
            }
          }, 200);
        }
      },
    });
  }

  loadScript(() => {
    let time = 1;

    if (window?.accountCenterFeedback) {
      feedBackInit();
      time = 11;
    }

    const timer = setInterval(() => {
      if (time <= 10) {
        if (window?.accountCenterFeedback) {
          clearInterval(timer);
          feedBackInit();
        }
        time++;
        return;
      }
      clearInterval(timer);
    }, 500);
  })
}

export function rateComponent(account: IUserLoginInfo, isMobile: boolean, el?: HTMLElement | null) {
  render(account, isMobile, el);
}
